import React from "react";

const Loading = () => {
  return (
    <section className=" fixed bg-black top-0 left-0 w-full h-full flex items-center justify-center">
      <div className="text-white flex flex-col items-center justify-center padding">
        <img src={"/loading.svg"} alt="loader" width={200} height={200} />
      </div>
    </section>
  );
};

export default Loading;
